import type { PrayerStatus } from '../../types';

type Props = {
  status: PrayerStatus;
  isOptional?: boolean;
};

export function StatusCircle({ status, isOptional = false }: Props) {
  if (status === 'done') {
    return <span className="inline-block h-3.5 w-3.5 rounded-full bg-child-accent" aria-label="done" />;
  }
  if (status === 'skipped') {
    return (
      <span
        className="inline-block h-3.5 w-3.5 rounded-full border border-dashed border-ink-subtle"
        aria-label="skipped"
      />
    );
  }
  if (status === 'in_progress') {
    return (
      <span
        className="inline-block h-3.5 w-3.5 rounded-full bg-child-fill ring-2 ring-child-accent"
        aria-label="in progress"
      />
    );
  }
  return (
    <span
      className={[
        'inline-block h-3.5 w-3.5 rounded-full border-[1.5px] border-ink-subtle',
        isOptional ? 'border-dashed' : '',
      ].join(' ')}
      aria-label="pending"
    />
  );
}
